import * as React from "react";
import {IconProps, getIconSize} from "./IconInterface"

export const IconDashboard = ({
  className,
  size = "md"
}: IconProps) => {
  const sizeOption = getIconSize(size)
  return (
    <svg className={`${className} ${sizeOption}`} xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <path d="M21.116 14.317C21.116 9.179 17.053 5 12.058 5S3 9.18 3 14.317A9.51 9.51 0 004.228 19l15.667-.025a9.416 9.416 0 001.221-4.658z" stroke="#1B1C22" stroke-width="2"/>
            <circle fill="#1B1C22" cx="12" cy="8" r="1"/>
            <circle fill="#1B1C22" cx="8" cy="11" r="1"/>
            <circle stroke="#1B1C22" stroke-width="2" cx="12.5" cy="14.5" r="1.5"/>
            <circle fill="#1B1C22" cx="17" cy="11" r="1"/>
            <path stroke="#1B1C22" stroke-width="2" stroke-linecap="round" d="M6.5 14.5h4"/>
        </g>
    </svg>
  )
}


